<p-accordion>
  <p-accordionTab header="Controles Internos" [selected]="true">
    <p-header style="font-weight:bolder;font-size:20px">
      Controles Internos
    </p-header>
    <p-accordion>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">1.1 e 1.2</span> MAPEAMENTO E MANUALIZAÇÃO
        </p-header>
        Dentre as áreas de atuação do RPPS que tenham sido mapeadas, deverão ser selecionados os processos e atividades que serão manualizados, ou seja, que terão definidos procedimentos padronizados de execução, desempenho, qualidade e reprodutividade.
        O diagnóstico sobre a organização deve ser feito a partir do reconhecimento e mapeamento dos processos executados e não somente pelos resultados obtidos. Os gestores devem ter uma visão sistêmica e abrangente da organização, por isso, como primeiro passo, é necessário que sejam mapeados os seus processos e atividades.
        <br>
        <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/11/Portaria-DIVIPREV-nº-196-2020.pdf" texto="Portaria DIVIPREV nº 196-2020"></app-meu-link>
        
        <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2021/01/Portaria-06-2021.pdf" texto="Portaria DIVIPREV nº 006-2021"></app-meu-link>
        
        <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2021/01/Portaria-07-2021.pdf" texto="Portaria DIVIPREV nº 007-2021"></app-meu-link>
        
        <p-fieldset legend="Arrecadação" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Manuais e Mapeamentos" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="arrecadacaoman"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Relatórios de Indicadores" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="arrecadacaorel"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Declaração de Ciência" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="arrecadacaodec"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>

        <p-fieldset legend="Benefícios" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Manuais e Mapeamentos" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapBeneficiosman"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Relatórios de Indicadores" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapBeneficiosrel"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Declaração de Ciência" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapBeneficiosdec"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>
        
        <p-fieldset legend="COMPREV" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Manuais e Mapeamentos" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapComprevman"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Relatórios de Indicadores" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapComprevRel"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Declaração de Ciência" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapComprevDec"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>

        <p-fieldset legend="Investimentos" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Manuais e Mapeamentos" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapInvestimentosman"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Relatórios de Indicadores" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapInvestimentosrel"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Declaração de Ciência" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapInvestimentosdec"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>

        

       
      
      </p-accordionTab>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">1.3</span> CERTIFICAÇÃO DOS DIRIGENTES, CONSELHEIROS, GESTOR DE RECURSOS E COMITÊ DE INVESTIMENTOS
        </p-header>
        Os dirigentes do órgão ou entidade gestora dos RPPS, os membros dos conselhos
deliberativo e fiscal, o responsável pela gestão das aplicações dos recursos e os membros do
comitê de investimentos deverão comprovar possuir certificação, conforme exigência prevista
no inciso II do art. 8º-B da Lei nº 9.717, de 1998, por meio de processo realizado por entidade
certificadora credenciada e certificados reconhecidos pela Comissão de Credenciamento e
Avaliação do Pró-Gestão e divulgados no endereço eletrônico da Secretaria de Previdência na
rede mundial de computadores – Internet, mediante Ato do Secretário de Previdência <br>
<app-meu-link link="https://diviprev.mg.gov.br/?page_id=9302" texto="Visitar página do Comitê de Investimentos"></app-meu-link>
<app-meu-link link="https://diviprev.mg.gov.br/?page_id=6123" texto="Visitar página do Conselho Administrativo"></app-meu-link>
<app-meu-link link="https://diviprev.mg.gov.br/?page_id=6127" texto="Visitar página do Conselho Fiscal"></app-meu-link>
<app-meu-link link="https://diviprev.mg.gov.br/?page_id=9958" texto="Acessar Diretoria Executiva"></app-meu-link>
      </p-accordionTab>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">1.4</span> ESTRUTURA DE CONTROLE INTERNO
        </p-header>
        O ente federativo deverá manter função de controle interno do RPPS, diretamente em sua
estrutura organizacional ou na unidade gestora do RPPS, integrada
ao seu sistema de controle interno, que terá, dentre outras, a finalidade de avaliar o
cumprimento de metas, programas e orçamentos e comprovar a legalidade, eficácia e eficiência
dos atos de gestão. <br>

      <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/10/Regimento-Controle-interno.pdf" texto="Regimento Interno"></app-meu-link>
        <br><br>
      <p-fieldset legend="Portarias de Nomeação" [toggleable]="true" [collapsed]="true">
        <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoCI"></app-lista-arquivos>
      </p-fieldset>
      
      <p-fieldset legend="Relatórios Auditoria Controle Interno" [toggleable]="true" [collapsed]="true">
        <app-lista-arquivos [miniMode]="true" categoria="relaudcontrinter"></app-lista-arquivos>
      </p-fieldset>

      <p-fieldset legend="Relatórios Trimestrais" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="relTriCI"></app-lista-arquivos>
      </p-fieldset>
      
      <p-fieldset legend="Relatórios Semestrais" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="relSemesCI"></app-lista-arquivos>
      </p-fieldset>

      <p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
      <app-lista-arquivos [miniMode]="true" categoria="certificadosCI"></app-lista-arquivos>
      </p-fieldset>     

</p-accordionTab>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">1.5</span> POLÍTICA DA SEGURANÇA DA INFORMAÇÃO
        </p-header>
        A informação é um ativo essencial da organização e precisa ser adequadamente protegida.
Conforme definição da Associação Brasileira de Normas Técnicas - ABNT (ISO 27002),
“Segurança da informação é a proteção da informação de vários tipos de ameaças, para garantir
a continuidade do negócio, minimizar o risco ao negócio, maximizar o retorno sobre os
investimentos e as oportunidades de negócio”.
<br>
<app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2024/03/PSI-e-Ata-COADI-e-publica%C3%A7%C3%A3o.pdf" texto="Documento da Política de Segurança da Informação"></app-meu-link>
<br>
<p-fieldset legend="Termo de Ciência e Compromisso" [toggleable]="true" [collapsed]="true">
  <p-fieldset legend="Prestador de Serviço" [toggleable]="true" [collapsed]="true">
    <app-lista-arquivos [miniMode]="true" categoria="termoccompromissopres"></app-lista-arquivos>
  </p-fieldset>
  <p-fieldset legend="Servidor" [toggleable]="true" [collapsed]="true">
    <app-lista-arquivos [miniMode]="true" categoria="termoccompromissoser"></app-lista-arquivos>
  </p-fieldset>
</p-fieldset>

      <p-fieldset legend="Tecnologia da Informação" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Manuais e Mapeamentos" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapTIman"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Relatórios de Indicadores" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapTIrel"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Declaração de Ciência" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="mapTIdec"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>

      </p-accordionTab>

      

      <p-accordionTab  >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">1.6</span> CONTROLE DA BASE DE DADOS
        </p-header>
        A atualização permanente da base de dados cadastrais permite ao ente federativo maior
controle da massa de seus segurados e garante que as avaliações atuariais anuais reflitam a
realidade dessa base, possibilitando dessa forma a correta organização e revisão dos planos de
custeio e benefícios, conforme estabelece o artigo 1º, inciso I da Lei nº 9.717/1998.
      <br>
      <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2026/05/DECRETO-17.330-2026-CENSO-ATIVOS.pdf" texto="Decreto Vigente"></app-meu-link> 
      <br><br>
      <p-fieldset legend="Censo" [toggleable]="true" [collapsed]="true">
        <p-fieldset legend="2016" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2016"></app-lista-arquivos>
        </p-fieldset>
        <p-fieldset legend="2017" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2017"></app-lista-arquivos>
        </p-fieldset>
        <p-fieldset legend="2020" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2020"></app-lista-arquivos>
        </p-fieldset>
        <p-fieldset legend="2021" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2021"></app-lista-arquivos>
        </p-fieldset>
        <p-fieldset legend="2022" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2022"></app-lista-arquivos>
        </p-fieldset> 
  
        <p-fieldset legend="2023" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2023"></app-lista-arquivos>
        </p-fieldset> 
        <p-fieldset legend="2024" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2024"></app-lista-arquivos>
        </p-fieldset> 
        <p-fieldset legend="2025" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2025"></app-lista-arquivos>
        </p-fieldset> 
        <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="censo2026"></app-lista-arquivos>
        </p-fieldset> 
      </p-fieldset>
      
      <p-fieldset legend="E-Social" [toggleable]="true" [collapsed]="true">
        <p-fieldset legend="ENTE" [toggleable]="true" [collapsed]="true">
          <!-- <app-lista-arquivos [miniMode]="true" categoria="esocialEnte"></app-lista-arquivos> -->
          <p-fieldset legend="2023" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialEnte2023"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2024" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialEnte2024"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2025" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialEnte2025"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialEnte2026"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>
        <p-fieldset legend="RPPS" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="2023" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialRpps2023"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2024" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialRpps2024"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2025" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialRpps2025"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="esocialRpps2026"></app-lista-arquivos>
          </p-fieldset>
          <!-- <app-lista-arquivos [miniMode]="true" categoria="esocialRpps"></app-lista-arquivos> -->
        </p-fieldset>
      
      </p-fieldset>

      </p-accordionTab>

      

      

      

      

      </p-accordion>
  </p-accordionTab>

  <p-accordionTab header="Governança Corporativa">
    <p-header style="font-weight:bolder;font-size:20px">
      Governança Corporativa
    </p-header>
     
    <p-accordion>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">2.1</span> RELATÓRIO DE GOVERNANÇA CORPORATIVA
        </p-header>
        Deve ser periodicamente disponibilizado pela unidade gestora do RPPS, em seu site, o Relatório de Governança Corporativa, instrumento de transparência e prestação de contas da gestão, que deverá ser previamente submetido à análise e aprovação do Conselho Fiscal e Conselho Deliberativo.
        <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10100" texto="Governança Corporativa"></app-meu-link><br>
      </p-accordionTab>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">2.2</span> PLANEJAMENTO
        </p-header>
        A unidade gestora do RPPS deve incorporar o planejamento à sua rotina de gestão e desenvolver Plano de Ação ou Planejamento Estratégico, ao qual deverá ser dada ampla divulgação, contemplando as ações a serem implementadas, metas para melhoria de cada processo, responsabilidades e prazos, bem como o monitoramento qualitativo de seus resultados.
        <app-lista-arquivos [miniMode]="true" categoria="planejamento"></app-lista-arquivos>
        <!-- <p-fieldset legend="Certidões e Declarações (Portaria 9.907/2020)" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="certidoesdiretoriaexecutiva"></app-lista-arquivos>
        </p-fieldset> -->
        
      </p-accordionTab>

      <p-accordionTab header="Controles Internos" >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">2.3</span> RELATÓRIO DE GESTAO ATUARIAL
        </p-header>
        O Relatório de Gestão Atuarial constitui importante ferramenta de monitoramento dos resultados atuariais dos planos de custeio e de benefícios e de gerenciamento do RPPS.
      <br>
      
      <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9362" texto="Ir para Relatórios de Gestão Atuarial"></app-meu-link>
      </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.4</span> CÓDIGO DE ÉTICA
          </p-header>
          O Código de Ética é um instrumento no qual são retratados a missão, a visão e os princípios de uma determinada organização, devendo ser difundido entre seus colaboradores, para que estes tenham ciência de suas responsabilidades. Por meio dele é possível conhecer os valores cultivados pela instituição e a função que ela exerce na sociedade.
        <br>
        <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/10/C%C3%B3digo-de-%C3%A9tica.pdf" texto="Código de Ética"></app-meu-link>
        <p-fieldset legend="Termo de Ciência e Compromisso" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Prestador de Serviço" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="termoccompromisso2pre"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Servidor" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="termoccompromisso2ser"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.5</span> POLÍTICAS PREVIDENCIÁRIAS DE SAÚDE E SEGURANÇA DO SERVIDOR
          </p-header>
          Sem prejuízo do cumprimento das obrigações legais cabíveis, a unidade gestora do RPPS e o ente federativo devem atuar de forma coordenada com o objetivo de adotar medidas preventivas, que visem à redução dos riscos inerentes ao ambiente de trabalho e das situações que provocam o adoecimento e a incapacidade laborativa dos servidores.
          <br>
          
          
          <p-fieldset legend="Exames Admissionais" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="examesAdmissionais"></app-lista-arquivos>
          </p-fieldset>
          <p-fieldset legend="Serviços de Perícia Médica" [toggleable]="true" [collapsed]="true">
            <p-fieldset legend="Diviprev" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="periciasMedicasDiv"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="Ente" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="periciasMedicasEnt"></app-lista-arquivos>
            </p-fieldset>
            
          </p-fieldset>
          <p-fieldset legend="Ações educativas para redução de acidente de trabalho" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="cipa"></app-lista-arquivos>
          </p-fieldset>
          <!-- <p-fieldset legend="Emissão PPP e LTCAT" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="pppltcat"></app-lista-arquivos>
          </p-fieldset> -->
          <p-fieldset legend="REVISÃO DE BENEFÍCIOS DE APOSENTADORIA POR INCAPACIDADE" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="revapos"></app-lista-arquivos>
          </p-fieldset>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.6</span> POLÍTICA DE INVESTIMENTOS
          </p-header>
          A Política de Investimentos é um dos processos estratégicos do RPPS, pois a adequada administração dos ativos é fundamental para que se assegure a sua sustentabilidade. Sua formulação encontra-se prevista nos art. 4º e 5º da Resolução CMN nº 3.922/2010 e representa instrumento para a observância dos princípios de segurança, rentabilidade, solvência, liquidez, diversificação, adequação à natureza de suas obrigações e transparência na aplicação dos recursos, e na avaliação de seus riscos.
          <br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=6107" texto="Politicas de Investimentos"></app-meu-link> <br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9256" texto="Relatórios de Investimentos"></app-meu-link> <br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9270" texto="Relatório ALM (Asset Liability Management)"></app-meu-link>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.7</span> COMITÊ DE INVESTIMENTOS
          </p-header>
          O Comitê de Investimentos é o órgão colegiado do RPPS que tem por atribuição específica participar do processo decisório de formulação e execução da Política de Investimentos, tendo seus requisitos básicos de instituição e funcionamento estabelecidos no art. 3º-A da Portaria MPS nº 519/2011. Sua atuação deve ser disciplinada em regimento interno, aprovado pelo Conselho Deliberativo, e seus membros devem atender aos requisitos de qualificação, padrões éticos de conduta e autonomia nas decisões.
          <br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9302" texto="Ir para Comitê de Investimentos"></app-meu-link>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.8</span> TRANSPARÊNCIA
          </p-header>
          A transparência nas organizações diz respeito à existência de políticas e procedimentos continuados e permanentes que permitam fornecer informações aos diversos interessados segundo critérios gerais de acesso, uso e entendimento.
          
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9368" texto="A) Regimentos e Atas dos Colegiados"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9239" texto="B) Certidões Negativas de Débitos"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10098" texto="C) Certidão e Extrato de Regularidade Previdenciária"></app-meu-link><br>

          
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10100" texto="D) Relatório de Governança Corporativa"></app-meu-link><br>
          <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2026/10/Cronograma-de-Educacao-Previdenciaria-2026.pdf" texto="E) Cronograma das ações de educação previdenciária"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9368" texto="F) Cronograma das reuniões de todos os colegiados"></app-meu-link><br>
          <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/10/C%C3%B3digo-de-%C3%A9tica.pdf" texto="G) Código de Ética"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9135" texto="H) Demonstrações Financeiras e Contábeis"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=8612" texto="I) Avaliação Atuarial Anual"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9158" texto="J) Informações relativas a procedimentos licitatórios e contratos administrativos."></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10103" texto="L) Planejamento Anual"></app-meu-link><br>
          
          
          
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=6107" texto="M) Política de Investimentos"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10108" texto="N) Relatórios semestrais do Controle Interno"></app-meu-link><br>
          
          
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9263" texto="O) Relação das entidades escolhidas para receber investimentos por meio do credenciamento."></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9256" texto="P) Relatórios mensais e anuais de investimentos"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9370" texto="Q) Acórdãos das decisões do tribunal de contas"></app-meu-link><br>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=10501" texto="R) Relatório do Regime de Previdência Complementar"></app-meu-link><br>
       
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.9</span> DEFINIÇÃO DOS LIMITES DE ALÇADA
          </p-header>
          
        <div style="text-align:center;width:100%">
          LEI COMPLEMENTAR Nº. 253/2026
SEÇÃO IV
Da Superintendência a estrutura organizacional


<div style="text-align: justify;margin-left: 10%;">
  Art. 82. Compete ao Superintendente:
[...]
X - assinar, em conjunto com o Gerente Financeiro, documentos relativos movimentações financeiras do DIVIPREV.

</div>



        </div>
        <br><p-fieldset legend="Decretos de Nomeação" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="decretoNomeacaoAlcada"></app-lista-arquivos>
        </p-fieldset>

        
        <app-meu-link link="https://diviprev.mg.gov.br/?page_id=6166" texto="APR"></app-meu-link><br>
        

        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.10</span> SEGREGAÇÃO DAS ATIVIDADES
          </p-header>
          <div style="text-align:center;width:100%">
           LEI COMPLEMENTAR Nº. 253/2026
SEÇÃO IV
Da Superintendência a estrutura organizacional


<div style="margin-left:10%;text-align:justify;">

 Art. 85. Compete ao Gerente Financeiro:
[...] <br>
IX - efetuar pagamentos aos servidores, beneficiários, prestadores de serviço e fornecedores.<br>

Art. 86. Compete ao Gerente de Benefícios assessorar o Superintendente nas seguintes atribuições:
[...]<br>
VII - preparar e remeter à Gerência de Pessoal as informações necessárias ao cadastro e pagamento dos benefícios.<br>

Art. 87. Compete ao Gerente de Pessoal assessorar o Superintendente nas seguintes atribuições:
[...]<br>
VII - confeccionar a folha de pagamento mensal dos servidores ativos, aposentados e pensionistas.

</div>


          </div>
          <br><p-fieldset legend="Portarias de Nomeação" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoSegregacao"></app-lista-arquivos>
          </p-fieldset>

        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.11</span> OUVIDORIA
          </p-header>
          A Ouvidoria é um serviço institucional para consultas, dúvidas, reclamações, denúncias, elogios e solicitações, que proporciona uma via de comunicação permanente entre a instituição e as pessoas ou grupos que nela possuem participação, investimentos ou outros interesses.
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9372" texto="Acessar Ouvidoria"></app-meu-link><br>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.12</span> DIRETORIA EXECUTIVA
          </p-header>
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=9958" texto="Acessar Diretoria Executiva"></app-meu-link><br>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.13</span> CONSELHO FISCAL
          </p-header>
          O RPPS deverá obrigatoriamente manter Conselho Fiscal, cuja periodicidade das reuniões e funcionamento sejam disciplinados pela legislação local
        
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=6127" texto="Conselho Fiscal"></app-meu-link><br>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.14</span> CONSELHO ADMINISTRATIVO
          </p-header>
          O RPPS deverá obrigatoriamente manter Conselho Deliberativo, cuja periodicidade das reuniões e funcionamento sejam disciplinados pela legislação local.
          <app-meu-link link="https://diviprev.mg.gov.br/?page_id=6123" texto="Conselho Administrativo"></app-meu-link><br>
        </p-accordionTab>

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.15</span> MANDATO, REPRESENTAÇÃO E RECONDUÇÃO
          </p-header>
          Caberá à legislação local disciplinar o processo de escolha dos membros da Diretoria Executiva, do Conselho Deliberativo e do Conselho Fiscal.
          <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2026/07/Mandato-representacao-e-reconducao.pdf" texto="Acerca do Mandato, Representação e Recondução"></app-meu-link><br>
          
        </p-accordionTab>

        

        

        <p-accordionTab header="Controles Internos" >
          <p-header style="font-weight:bolder;font-size:15px">
            <span style="color:blue">2.16</span> GESTÃO DE PESSOAS
          </p-header>
          Caberá à legislação local definir o quadro de pessoal do RPPS, de acordo com o seu porte, e estabelecer objetivos de gestão de pessoal, qualificação e treinamento. <br><br> 

          <div style="text-align: justify;margin-left: 12%;">
            <div style="text-align: center;width:100%">
              <br>
              <b>
              LEI COMPLEMENTAR Nº. 253/2026
SEÇÃO IV</b><br>
Da Superintendência a estrutura administrativa

            </div>


<br>
Art. 84. O quadro de pessoal do DIVIPREV terá a seguinte composição:<br><br>
I - Cargos em comissão:<br>
a) Superintendente - com nível GH 8;<br>
b) Gerente Financeiro - com nível GH 5;<br>
c) Gerente de Benefícios - com nível GH 5;<br>
d) Gerente de Pessoal - com nível GH 5.
<br><br>
II - Cargos efetivos:<br>
a) 14 (dez) Agentes de Administração;
b) 03 (três) Advogados;<br>
c) 02 (dois) Contadores;<br>
d) 01 (um) Técnico em Informática;<br>
e) 02 (dois) Telefonistas.<br>
§ 1º Os cargos mencionados nas alíneas "b", "c" e "d" são de recrutamento restrito aos servidores efetivos do quadro de pessoal do DIVIPREV.<br>
§ 2º Os cargos de provimento efetivo serão obrigatoriamente preenchidos mediante concurso público.


          </div>


          <br><p-fieldset legend="Portarias de Nomeação" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoGesPessoas"></app-lista-arquivos>
          </p-fieldset>

          <br><p-fieldset legend="Concurso Público" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="concursoPublico"></app-lista-arquivos>
          </p-fieldset>
        </p-accordionTab>

        

        

        

        

        

        

        

        

        

    </p-accordion>
    

  </p-accordionTab>

  <p-accordionTab header="Educação Previdenciária">
    <p-header style="font-weight:bolder;font-size:20px">
      Educação Previdenciária
    </p-header>

    <p-accordion>
      <p-accordionTab >
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">3.1</span> PLANO DE AÇÃO DE CAPACITAÇÃO
        </p-header>
        O RPPS deverá desenvolver plano de ação de capacitação para os servidores que atuem na unidade gestora, seus dirigentes e conselheiros.
        <br><p-fieldset legend="Plano de Ação de Capacitação" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacao"></app-lista-arquivos>
        </p-fieldset>

        <p-fieldset legend="Cursos Capacitação Disponíves" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
            <app-lista-arquivos [miniMode]="true" categoria="cursosCap2026"></app-lista-arquivos>
          </p-fieldset>
        </p-fieldset>

        <p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
          <p-fieldset legend="Servidor" [toggleable]="true" [collapsed]="true">
            <p-fieldset legend="2019" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2019"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2020" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2020"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2021" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2021"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2022" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2022"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2023" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2023"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2024" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2024"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2025" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2025"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoServ2026"></app-lista-arquivos>
            </p-fieldset>
          </p-fieldset>
          <p-fieldset legend="Conselheiro" [toggleable]="true" [collapsed]="true">
            <p-fieldset legend="2019" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2019"></app-lista-arquivos>
            </p-fieldset>
            <!-- <p-fieldset legend="2020" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2020"></app-lista-arquivos>
            </p-fieldset> -->
            <p-fieldset legend="2021" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2021"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2022" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2022"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2023" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2023"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2024" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2024"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2025" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2025"></app-lista-arquivos>
            </p-fieldset>
            <p-fieldset legend="2026" [toggleable]="true" [collapsed]="true">
              <app-lista-arquivos [miniMode]="true" categoria="planoAcaoCapacitacaoConse2026"></app-lista-arquivos>
            </p-fieldset>
          </p-fieldset>
        </p-fieldset>
      </p-accordionTab>

      <p-accordionTab>
        <p-header style="font-weight:bolder;font-size:15px">
          <span style="color:blue">3.2</span>  AÇÕES E DIÁLOGO COM SOCIEDADE E SEGURADOS
        </p-header>
        <app-meu-link link="https://www.diviprev.mg.gov.br/wp-content/uploads/2020/11/Cartilha.pdf" texto="Cartilha Previdenciária"></app-meu-link><br>
        
        <p-fieldset legend="Cronograma de ações de educação previdenciária" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="seminariosSegurados"></app-lista-arquivos>
        </p-fieldset>
        
        <p-fieldset legend="Ações de Preparação para aposentadoria" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="acoesAposentadoria"></app-lista-arquivos>
        </p-fieldset>

        <p-fieldset legend="Ações de Pos aposentadoria" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="acoesPosAposentadoria"></app-lista-arquivos>
        </p-fieldset>
        
        <p-fieldset legend="Audiências Públicas" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="prestacoesCamara"></app-lista-arquivos>
        </p-fieldset>

        <p-fieldset legend="Responsabilidade Corporativa e Social" [toggleable]="true" [collapsed]="true">
          <app-lista-arquivos [miniMode]="true" categoria="responsabilidadeCorporativa"></app-lista-arquivos>
        </p-fieldset>
        
      </p-accordionTab>
      
      
      
    </p-accordion>
     
  </p-accordionTab>
</p-accordion>